import { useCurrentUser } from '../user';

export const useShowInvitePartner = (): boolean => {
    const { partnerInfo, outgoingPartnershipInvite } = useCurrentUser();

    // Show partner invite content if:
    // 1. User's partner has not joined Plenty (no user ID); and
    // 2. User has not sent a partnership invite
    return !partnerInfo?.userId && !outgoingPartnershipInvite;
};
